import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import './services.css';

const licenciaturaData = [
  {
    id: 1,
    title: 'Licenciatura em Análises Clínicas',
    duration: '5 anos',
    description: 'Explore a Licenciatura em Análises Clínicas: ciência, precisão e inovação para garantir diagnósticos confiáveis e cuidados de saúde de qualidade.',
    path: '/programas/licenciatura/detalhes-cursos/1'
  },
  {
    id: 2,
    title: 'Licenciatura em Engenharia Informática',
    duration: '4 anos',
    description: 'Desbrave a Engenharia Informática: inovação digital, tecnologia de ponta e soluções para os desafios do mundo moderno.',
    path: '/programas/licenciatura/detalhes-cursos/2'
  },
  {
    id: 3,
    title: 'Licenciatura em Pedagogia',
    duration: '4 anos',
    description: 'Explore a Pedagogia: transformando a educação com métodos inovadores e inspiradores para o desenvolvimento das futuras gerações.',
    path: '/programas/licenciatura/detalhes-cursos/3'
  },
  {
    id: 4,
    title: 'Licenciatura em Sociologia',
    duration: '4 anos',
    description: 'A Sociologia analisa questões como cultura, poder, desigualdade, mudança social e dinâmicas de grupo.',
    path: '/programas/licenciatura/detalhes-cursos/4'
  },
  {
    id: 5,
    title: 'Licenciatura em Direito',
    duration: '5 anos',
    description: 'Desvende a Licenciatura em Direito: explorando a justiça, a ética e os desafios contemporâneos do sistema legal.',
    path: '/programas/licenciatura/detalhes-cursos/5'
  },
  {
    id: 6,
    title: 'Licenciatura em Gestão de Empresas',
    duration: '4 anos',
    description: 'Descubra a Gestão de Empresas: estratégia, inovação e liderança para impulsionar o sucesso organizacional.',
    path: '/programas/licenciatura/detalhes-cursos/6'
  },
  {
    id: 7,
    title: 'Licenciatura em Enfermagem',
    duration: '4 anos',
    description: 'Descubra a Enfermagem: cuidado, inovação e dedicação para promover a saúde e o bem-estar da comunidade.',
    path: '/programas/licenciatura/detalhes-cursos/7'
  },
  {
    id: 8,
    title: 'Licenciatura em Contabilidade',
    duration: '4 anos',
    description: 'Descubra a Contabilidade: precisão, ética e inovação na gestão financeira e contábil.',
    path: '/programas/licenciatura/detalhes-cursos/8'
  },
  {
    id: 9,
    title: 'Licenciatura em Economia',
    duration: '4 anos',
    description: 'Descubra a Economia: análise, inovação e estratégias para promover o desenvolvimento sustentável.',
    path: '/programas/licenciatura/detalhes-cursos/9'
  },
  {
    id: 10,
    title: 'Licenciatura em Engenharia Civil',
    duration: '5 anos',
    description: 'Descubra a Engenharia Civil: construção, inovação e sustentabilidade para moldar o futuro das infraestruturas.',
    path: '/programas/licenciatura/detalhes-cursos/10'
  },
  {
    id: 11,
    title: 'Licenciatura em Farmacêuticas',
    duration: '5 anos',
    description: 'Descubra a Farmácia: ciência, inovação e cuidado na promoção da saúde e bem-estar da comunidade.',
    path: '/programas/licenciatura/detalhes-cursos/11'
  },
  {
    id: 12,
    title: 'Licenciatura em Recursos Humanos',
    duration: '4 anos',
    description: 'Descubra a Gestão de Recursos Humanos: estratégias para atrair, desenvolver e reter talentos nas organizações.',
    path: '/programas/licenciatura/detalhes-cursos/12'
  },
  {
    id: 13,
    title: 'Licenciatura em Psicologia',
    duration: '4 anos',
    description: 'Descubra a Psicologia: compreensão da mente humana, comportamento e emoções para promover o bem-estar.',
    path: '/programas/licenciatura/detalhes-cursos/13'
  },
  {
    id: 14,
    title: 'Licenciatura em Relações Internacionais',
    duration: '4 anos',
    description: 'Descubra as Relações Internacionais: diplomacia, comércio global e cooperação internacional para um mundo interconectado.',
    path: '/programas/licenciatura/detalhes-cursos/14'
  }
];

const iconMap = {
  'Licenciatura em Ciências da Saúde': 'fas fa-heartbeat',
  'Licenciatura em Engenharia Informática': 'fas fa-laptop-code',
  'Licenciatura em Pedagogia': 'fas fa-chalkboard-teacher',
  'Licenciatura em Sociologia': 'fas fa-users',
  'Licenciatura em Direito': 'fas fa-balance-scale',
  'Licenciatura em Gestão de Empresas': 'fas fa-briefcase',
  'Licenciatura em Enfermagem': 'fas fa-user-nurse'
};

function AppServices() {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: false,
    rootMargin: '0px 0px -20% 0px'
  });

  return (
    <motion.section
      ref={ref}
      id="licenciaturas"
      className="block services-block"
      style={{
        backgroundColor: '#ffffff',
        padding: '40px 0',
        border: 'none'
      }}
      initial={{ opacity: 0, y: 100 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
      transition={{ duration: 0.8, ease: 'easeInOut' }}
    >
      <Container fluid>
        <Container>
          <Row>
            <Col>
              {/* Título para Mobile */}
              <div className="d-block d-md-none text-center mb-4">
                <h2 style={{ color: '#00761F', fontWeight: '700', fontSize: '1.8rem' }}>
                  Nossos Cursos
                </h2>
                <p style={{ color: '#666', fontSize: '1rem' }}>
                  Descubra as licenciaturas disponíveis
                </p>
              </div>

              <motion.div
                className="table-container"
                style={{
                  background: '#fff',
                  borderRadius: '12px',
                  boxShadow: '0 6px 24px rgba(0,0,0,0.07)',
                  overflow: 'hidden'
                }}
                initial={{ opacity: 0, y: 40 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 40 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                {/* Tabela para Desktop */}
                <div className="d-none d-md-block">
                  <Table responsive hover style={{ margin: 0 }}>
                    <thead style={{ backgroundColor: '#00761F' }}>
                      <tr>
                        <th style={{ color: '#00761F', padding: '20px', fontSize: '1.1rem', textAlign: 'left' }}>
                          <i className="fas fa-graduation-cap" style={{ marginRight: '10px' }}></i>
                          Curso
                        </th>
                        <th style={{ color: '#00761F', padding: '20px', fontSize: '1.1rem', textAlign: 'center' }}>
                          <i className="fas fa-clock" style={{ marginRight: '10px' }}></i>
                          Duração
                        </th>
                        <th style={{ color: '#00761F', padding: '20px', fontSize: '1.1rem', textAlign: 'center' }}>
                          <i className="fas fa-info-circle" style={{ marginRight: '10px' }}></i>
                          Detalhes
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {licenciaturaData.map((curso) => (
                        <motion.tr
                          key={curso.id}
                          style={{
                            backgroundColor: 'white',
                            transition: 'all 0.3s ease'
                          }}
                          whileHover={{ backgroundColor: '#f0f7f0' }}
                        >
                          <td style={{ padding: '20px', verticalAlign: 'middle' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <div
                                style={{
                                  background: 'linear-gradient(135deg, #00761F 60%, #00c853 100%)',
                                  borderRadius: '50%',
                                  width: '50px',
                                  height: '50px',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  marginRight: '15px',
                                  flexShrink: 0
                                }}
                              >
                                <i
                                  className={iconMap[curso.title] || 'fas fa-graduation-cap'}
                                  style={{ color: '#fff', fontSize: '1.2rem' }}
                                ></i>
                              </div>
                              <div style={{ flex: 1 }}>
                                <h6 style={{ fontWeight: '600', color: '#00761F', margin: 0, fontSize: '1rem' }}>
                                  {curso.title}
                                </h6>
                                <p style={{ color: '#666', fontSize: '0.9rem', margin: '5px 0 0 0', lineHeight: '1.4' }}>
                                  {curso.description}
                                </p>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'middle', textAlign: 'center' }}>
                            <span
                              style={{
                                backgroundColor: '#e8f5e9',
                                color: '#00761F',
                                padding: '8px 16px',
                                borderRadius: '20px',
                                fontWeight: '600',
                                fontSize: '0.9rem',
                                display: 'inline-block'
                              }}
                            >
                              {curso.duration}
                            </span>
                          </td>
                          <td style={{ padding: '20px', verticalAlign: 'middle', textAlign: 'center' }}>
                            <Link 
                              to={curso.path} 
                              style={{ textDecoration: 'none' }}
                            >
                              <motion.div
                                whileHover={{ scale: 1.05 }}
                                whileTap={{ scale: 0.95 }}
                                style={{
                                  width: '45px',
                                  height: '45px',
                                  borderRadius: '50%',
                                  backgroundColor: '#00761F',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  margin: '0 auto',
                                  cursor: 'pointer'
                                }}
                              >
                                <i
                                  className="fas fa-arrow-right"
                                  style={{ color: 'white', fontSize: '1rem' }}
                                ></i>
                              </motion.div>
                            </Link>
                          </td>
                        </motion.tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Cards para Mobile */}
                <div className="d-block d-md-none">
                  <div style={{ padding: '15px' }}>
                    {licenciaturaData.map((curso) => (
                      <motion.div
                        key={curso.id}
                        style={{
                          backgroundColor: 'white',
                          borderRadius: '12px',
                          padding: '20px',
                          marginBottom: '15px',
                          boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
                          border: '1px solid #e0e0e0'
                        }}
                        whileHover={{ backgroundColor: '#f8fff9' }}
                        transition={{ duration: 0.3 }}
                      >
                        <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '15px' }}>
                          <div
                            style={{
                              background: 'linear-gradient(135deg, #00761F 60%, #00c853 100%)',
                              borderRadius: '50%',
                              width: '45px',
                              height: '45px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              marginRight: '12px',
                              flexShrink: 0
                            }}
                          >
                            <i
                              className={iconMap[curso.title] || 'fas fa-graduation-cap'}
                              style={{ color: '#fff', fontSize: '1.1rem' }}
                            ></i>
                          </div>
                          <div style={{ flex: 1 }}>
                            <h6 style={{ 
                              fontWeight: '600', 
                              color: '#00761F', 
                              margin: '0 0 5px 0', 
                              fontSize: '1rem',
                              lineHeight: '1.3'
                            }}>
                              {curso.title}
                            </h6>
                            <p style={{ 
                              color: '#666', 
                              fontSize: '0.85rem', 
                              margin: 0, 
                              lineHeight: '1.4' 
                            }}>
                              {curso.description}
                            </p>
                          </div>
                        </div>
                        
                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center',
                          borderTop: '1px solid #e8f5e9',
                          paddingTop: '15px'
                        }}>
                          <span
                            style={{
                              backgroundColor: '#e8f5e9',
                              color: '#00761F',
                              padding: '6px 12px',
                              borderRadius: '15px',
                              fontWeight: '600',
                              fontSize: '0.8rem'
                            }}
                          >
                            <i className="fas fa-clock" style={{ marginRight: '5px' }}></i>
                            {curso.duration}
                          </span>
                          
                          <Link 
                            to={curso.path} 
                            style={{ textDecoration: 'none' }}
                          >
                            <motion.div
                              whileHover={{ scale: 1.05 }}
                              whileTap={{ scale: 0.95 }}
                              style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: '#00761F',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer'
                              }}
                            >
                              <i
                                className="fas fa-arrow-right"
                                style={{ color: 'white', fontSize: '0.9rem' }}
                              ></i>
                            </motion.div>
                          </Link>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                </div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </Container>
    </motion.section>
  );
}

export default AppServices;